module.exports = __webpack_public_path__ + "static/Poppins-Medium-f61a4eb27371b7453bf5b12ab3648b9e.ttf";